document.addEventListener('DOMContentLoaded', function() {
  // Get all collapsible tabs
  const accordions = document.querySelectorAll('.accordion details');
  
  accordions.forEach(accordion => {
    const summary = accordion.querySelector('summary');
    const content = accordion.querySelector('.accordion__content');
    
    // We need to manually handle the click event
    summary.addEventListener('click', function(e) {
      e.preventDefault(); // Prevent default toggle behavior
      
      // Toggle our own open state
      if (accordion.hasAttribute('open')) {
        // Close accordion - animate first, then remove attribute
        const currentHeight = content.scrollHeight;
        
        // Set fixed height so we can animate from it
        content.style.height = currentHeight + 'px';
        
        // Force a reflow
        content.offsetHeight;
        
        // Animate to 0
        content.style.height = '0px';
        
        // After animation completes, remove the open attribute
        setTimeout(() => {
          accordion.removeAttribute('open');
          // Reset height to default controlled by CSS
          content.style.height = '';
        }, 300); // Match this to your transition duration
      } else {
        // Open accordion - set attribute first, then animate
        accordion.setAttribute('open', '');
        
        // Get the scroll height now that it's open
        const contentHeight = content.scrollHeight;
        
        // Start from 0 height
        content.style.height = '0px';
        
        // Force a reflow
        content.offsetHeight;
        
        // Animate to full height
        content.style.height = contentHeight + 'px';
        
        // After animation completes, set height to auto
        setTimeout(() => {
          content.style.height = 'auto';
        }, 300); // Match this to your transition duration
      }
    });
  });
});